module.exports = __webpack_public_path__ + "35356f84de391914eaabf846becb5511.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/emojis/score-6.svg
// module id = 31
// module chunks = 0